import $ from "jquery"

export const smoothScrollToID = (link, id) => {
    $(document).ready(() => {
        $(link).click(() => {
            $('html, body').animate({
                scrollTop: $(id).offset().top
            }, 1000);
        })
    })
}
